"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerCard = exports.ClickableCard = exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var Card = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default(classes_1.addClassName('card'), 'bg-white block p-8 rounded', className) }, props), children));
};
exports.Card = Card;
var ClickableCard = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default(classes_1.addClassName('clickable-card'), 'flex-1 bg-white shadow hover:shadow-lg rounded transition-shadow', className) }, props), children));
};
exports.ClickableCard = ClickableCard;
var InnerCard = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default(classes_1.addClassName('inner-card'), 'border border-grey-lightest rounded p-6', className) }, props), children));
};
exports.InnerCard = InnerCard;
//# sourceMappingURL=cards.js.map